import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { getDateFromString } from '../utils'
import { DataPanel } from './DataPanel'
import { DataTable } from './DataTable'

interface PhysicianClaimServicesProps {
    data: any
}

export const PhysicianClaimServices = ({ data }: PhysicianClaimServicesProps) => {
    let isClaimPrivateDataAvailable = false
    let professionalServicesDisplay
    const serviceLineSummaryTotal = data.claim?.privateData?.professionalServices
        ?.map((item: any) => parseFloat(item.amount))
        .reduce((a: number, b: number) => a + b)
        .toFixed(2)
    if (data.claim !== undefined) {
        const privateData = data.claim?.privateData
        if (privateData !== undefined) {
            isClaimPrivateDataAvailable = true
            if (data.claim?.privateData?.professionalServices !== undefined) {
                professionalServicesDisplay = (
                    <>
                        <DataTable
                            isPrivateDataAvailable={isClaimPrivateDataAvailable}
                            data={[
                                {
                                    key: 'Lines',
                                    value: `${data.claim?.privateData?.professionalServices.length}`,
                                    private: true,
                                },
                                {
                                    key: 'Total Charged',
                                    value: `$${serviceLineSummaryTotal}`,
                                    private: true,
                                },
                                { key: 'Total Paid', value: '--', private: true },
                                { key: 'Difference', value: '--', private: true },
                            ]}
                        />
                        <Box
                            sx={{
                                marginTop: '20px',
                                marginBottom: '20px',
                                borderBottom: 1,
                                borderColor: 'divider',
                            }}
                        />
                        <Box style={{ borderRadius: '10px', backgroundColor: '#F2F6F9' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Line Item</TableCell>
                                        <TableCell>Service From Date</TableCell>
                                        <TableCell>Service To Date</TableCell>
                                        <TableCell>CPT</TableCell>
                                        <TableCell>Unit</TableCell>
                                        <TableCell>Modifier</TableCell>
                                        <TableCell>Charge</TableCell>
                                        <TableCell>Paid</TableCell>
                                        <TableCell>Difference</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.claim?.privateData?.professionalServices.map(
                                        (item: any) => (
                                            <TableRow
                                                key={item.serviceLine}
                                                style={{
                                                    textAlign: 'center',
                                                    height: '30px',
                                                    color: '#0D3049',
                                                }}
                                            >
                                                <TableCell>{item.serviceLine}</TableCell>
                                                <TableCell>
                                                    {data.claim?.publicData.dateOfService
                                                        ? getDateFromString(
                                                              data.claim?.publicData.dateOfService,
                                                          ).toLocaleDateString()
                                                        : '--'}
                                                </TableCell>
                                                <TableCell>
                                                    {data.claim?.publicData.dateOfService
                                                        ? getDateFromString(
                                                              data.claim?.publicData.dateOfService,
                                                          ).toLocaleDateString()
                                                        : '--'}
                                                </TableCell>
                                                <TableCell>{item.procedureCode}</TableCell>
                                                <TableCell>{item.unit}</TableCell>
                                                <TableCell>{item.modifier ?? '--'}</TableCell>
                                                <TableCell>{`$${item.amount}`}</TableCell>
                                                <TableCell>--</TableCell>
                                                <TableCell>--</TableCell>
                                            </TableRow>
                                        ),
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </>
                )
            }
        }
    } else {
        isClaimPrivateDataAvailable = true
    }
    return (
        <Grid container xs={12} spacing={4}>
            <Grid item xs={12}>
                <DataPanel
                    minHeight={150}
                    title="Service Line Summary"
                    content={professionalServicesDisplay ?? <></>}
                />
            </Grid>
        </Grid>
    )
}
